import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contex/AuthContext";

export default function LoginScreen() {
  const { signIn, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signIn(email, password);
      navigate("/");
    } catch (err) {
      setError("Invalid email or password. Please try again.");
    }
    setLoading(false);
  };

  const handleGoogle = async () => {
    setError("");
    setLoading(true);
    try {
      await signInWithGoogle();
      navigate("/");
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.logo}>Study<span style={{color:"#7C6EF8"}}>OS</span></div>
      <div style={styles.tagline}>Welcome back 👋</div>

      <form onSubmit={handleLogin} style={styles.form}>
        <div style={styles.group}>
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" placeholder="your@email.com"
            value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div style={styles.group}>
          <label style={styles.label}>Password</label>
          <input style={styles.input} type="password" placeholder="••••••••"
            value={password} onChange={e => setPassword(e.target.value)} required />
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.primaryBtn} type="submit" disabled={loading}>
          {loading ? "Signing in..." : "Sign in"}
        </button>
      </form>

      <button style={styles.googleBtn} onClick={handleGoogle} disabled={loading}>
        <span>G</span> Sign in with Google
      </button>

      <div style={styles.links}>
        <button style={styles.linkBtn} onClick={() => navigate("/forgot-password")}>
          Forgot password?
        </button>
        <button style={styles.linkBtn} onClick={() => navigate("/signup")}>
          Don't have an account? Sign up
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap:       { minHeight:"100vh", background:"#0F0F13", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px" },
  logo:       { fontSize:"32px", fontWeight:700, color:"#F0EFE8", letterSpacing:"-1px", marginBottom:"8px" },
  tagline:    { fontSize:"16px", color:"#9998A0", marginBottom:"40px" },
  form:       { width:"100%", maxWidth:"360px" },
  group:      { marginBottom:"16px" },
  label:      { display:"block", fontSize:"12px", fontWeight:600, color:"#9998A0", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"6px" },
  input:      { width:"100%", padding:"14px 16px", background:"#18181F", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", color:"#F0EFE8", outline:"none" },
  error:      { fontSize:"13px", color:"#F05D5D", marginBottom:"12px" },
  primaryBtn: { width:"100%", padding:"15px", background:"#7C6EF8", border:"none", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"12px", maxWidth:"360px" },
  googleBtn:  { width:"100%", maxWidth:"360px", padding:"14px", background:"transparent", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:500, color:"#F0EFE8", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:"10px", marginBottom:"24px" },
  links:      { display:"flex", flexDirection:"column", alignItems:"center", gap:"12px" },
  linkBtn:    { background:"none", border:"none", fontFamily:"inherit", fontSize:"14px", color:"#7C6EF8", cursor:"pointer", textDecoration:"underline" },
};